import { render, staticRenderFns } from "./orderReceive.vue?vue&type=template&id=00eaed39&"
import script from "./orderReceive.vue?vue&type=script&lang=js&"
export * from "./orderReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports